import React from "react";

const SuraLogoWithText = ({ width = 228, height = 50, blue = "#355A88" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 228 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M51.1111 0H0V22.6968V24.6828H16.1683V15.3401H51.1111V0Z"
        fill={blue}
      />
      <path
        d="M0 50.0002H51.1111V26.6139V25.3372H34.9629V34.6838H0V50.0002Z"
        fill={blue}
      />
      <path
        d="M69.0052 29.124C71.1682 30.9326 73.8871 31.9847 76.7308 32.1108C79.2765 32.1108 80.4769 31.2518 80.4769 29.8923C80.4769 28.3556 78.5354 27.8118 75.9897 27.3114C72.151 26.5863 67.2006 25.6879 67.2006 20.4787C67.2006 16.8141 70.4834 13.5987 76.3603 13.5987C79.627 13.5554 82.8091 14.6114 85.3789 16.5855L83.0185 20.522C81.2341 18.867 78.8616 17.9568 76.4046 17.9883C74.2778 17.9883 72.8881 18.7567 72.8881 20.0255C72.8881 21.381 74.6443 21.8815 77.1457 22.378C80.9844 23.103 86.1201 24.0999 86.1201 29.5298C86.1201 33.5136 82.652 36.5438 76.4529 36.5438C72.8116 36.6344 69.2589 35.4286 66.4595 33.1511L69.0052 29.124Z"
        fill="#232735"
      />
      <path
        d="M104.802 33.2414C102.784 35.389 99.9198 36.5908 96.9391 36.5435C92.033 36.5435 89.7209 33.9192 89.7209 29.6635V14.1422H95.5978V27.4017C95.5978 30.4359 97.217 31.4288 99.7144 31.4288C101.708 31.3973 103.581 30.4831 104.802 28.9385V14.1422H110.679V35.9997H104.802V33.2414Z"
        fill="#232735"
      />
      <path
        d="M115.766 14.142H121.639V17.1288C123.383 15.0089 125.981 13.7401 128.761 13.6455V19.2567C126.134 18.6656 123.387 19.5561 121.639 21.5658V36.0035H115.762L115.766 14.142Z"
        fill="#232735"
      />
      <path
        d="M147.176 33.194C145.537 35.3021 142.987 36.5394 140.284 36.5434C134.641 36.5434 130.383 32.3783 130.383 25.0925C130.383 17.9406 134.593 13.5983 140.284 13.5983C142.991 13.5904 145.549 14.8317 147.176 16.9477V14.1421H153.097V36.0035H147.176V33.194ZM147.176 21.2467C145.972 19.6823 144.087 18.7642 142.089 18.7563C138.757 18.7563 136.445 21.29 136.445 25.0925C136.445 28.8477 138.757 31.4287 142.089 31.4287C144.091 31.4248 145.972 30.5027 147.176 28.9384V21.2467Z"
        fill="#232735"
      />
      <path
        d="M158.217 5.81592H164.094V35.9995H158.217V5.81592Z"
        fill="#232735"
      />
      <path
        d="M168.577 7.49077C168.577 5.59149 170.152 4.05078 172.093 4.05078C174.035 4.05078 175.61 5.59149 175.61 7.49077C175.61 9.39005 174.035 10.9308 172.093 10.9308C170.16 10.915 168.593 9.38217 168.577 7.49077ZM169.181 14.1422H175.058V35.9997H169.181V14.1422Z"
        fill="#232735"
      />
      <path
        d="M195.226 22.7874C195.226 19.7532 193.607 18.713 191.109 18.713C189.091 18.7327 187.202 19.6902 186.022 21.2939V36.0075H180.145V14.1421H186.022V16.9949C187.996 14.8001 190.852 13.5628 193.84 13.6022C198.742 13.6022 201.103 16.3172 201.103 20.5689V36.0114H195.226V22.7874Z"
        fill="#232735"
      />
      <path
        d="M214.722 27.5828L212.039 30.3884V35.9995H206.162V5.81592H212.039V23.8749L220.506 14.146H227.724L218.887 24.0561L228.002 36.0035H220.643L214.722 27.5828Z"
        fill="#232735"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="228" height="50" />
      </clipPath>
    </defs>
  </svg>
);

export default SuraLogoWithText;
